import { Component, OnInit, Input, Optional, Self, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, NgControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'intelli-decimal',
  templateUrl: './intelli-decimal.component.html',
  styleUrls: ['./intelli-decimal.component.css'],
  providers: [
    DatePipe,
    { provide: MatFormFieldControl, useExisting: IntelliDecimalComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class IntelliDecimalComponent implements MatFormFieldControl<number>, ControlValueAccessor, OnInit, OnChanges {



  @Input() public fractionDigits: number = 2;

  autofilled?: boolean;
  public datemask = [/[1-9]+/, ',', /\d/, /\d/];
  static nextId = 0;
  mainForm: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'intelli-decimal';
  id = `intelli-decimal-${IntelliDecimalComponent.nextId++}`;
  describedBy = '';
  private _value: number;


  private onChange: (value: number) => void;

  public changeDate() {
    this.onChange(this.value);
  }

  ngOnInit(): void {
    //  throw new Error("Method not implemented.");
  }

  writeValue(value: number): void {

    this.value = value;
  }
  registerOnChange(onChange: (value: number) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.mainForm.get("textDate").disable();
    }
    else {
      this.mainForm.get("textDate").enable();
    }
  }



  get empty() {

    return false;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): number | null {


    return this._value;
  }

  set value(value: number | null) {

    this._value = value || 0;

    console.log(this._value);

    this.mainForm.get("textDate").setValue(this._value.toFixed(this.fractionDigits));


    this.mainForm.get("textDate")
      .valueChanges
      .subscribe(value => {

        let fixedValue = this.fix(value)


        if (value != fixedValue.toFixed(this.fractionDigits)) {
          this.mainForm.get("textDate").setValue(fixedValue.toFixed(this.fractionDigits));
        }

        if (this._value != fixedValue) {
          this._value = fixedValue;
          this.onChange(this.value);
        }
      });

    this.stateChanges.next();
  }

  public fix(value: string): number {



    let len = value.length;

    let numbers = "0123456789";

    let result = "";
    for (let i = 0; i < len; i++) {
      let ch = value.substring(i, i + 1);

      if (numbers.indexOf(ch) >= 0) {
        result += ch;
      }
    }
    let resultNumber = (parseInt(result) / Math.pow(10, this.fractionDigits));

    return resultNumber;

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.mainForm.get("textDate").setValue(this._value.toFixed(this.fractionDigits));
  }


  constructor(@Optional() @Self() public ngControl: NgControl, private datePipe: DatePipe, fb: UntypedFormBuilder, private fm: FocusMonitor, private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.mainForm = fb.group({
      textDate: "0.00"
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input')!.focus();
    }
  }
}